import { Client } from 'openapi-fetch'

import type { paths } from '@kidzonet/ts-api-generator/clients/dashboard'

declare global {
    // eslint-disable-next-line vars-on-top
    var DashboardApiClient: Client<paths>
}

export const getInterfacesList = async () => {
    const { data, error } = await globalThis.DashboardApiClient.GET(
        '/v1/public/dashboard/interfaces',
    )

    if (error) {
        throw error
    }
    const { items = [] } = data
    return items.map(net => ({ id: net.id, address: net.interface }))
}

export const createInterface = async (address: string) => {
    const { data, error } = await globalThis.DashboardApiClient.POST(
        '/v1/public/dashboard/interfaces', {
            body: { interface: address },
        },
    )
    if (data) {
        return data.id
    }
    throw error
}

export const deleteInterface = async (id: number) => {
    const { data, error } = await globalThis.DashboardApiClient.DELETE(
        `/v1/public/dashboard/interfaces/{interface_id}`,
        {
            params: { path: { interface_id: id } },
        },
    )

    if (data) {
        return true
    }
    if (error && 'status' in error && error.status === 404) {
        return true
    }
    throw error
}
